import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/cash/apply/list'
    return request.post(url,data)
}

export function all() {
    let url = '/cash/apply/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/cash/apply/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/cash/apply/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/cash/apply/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/cash/apply/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/cash/apply/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/cash/apply/dmz/options'
    return request.get(url)
}
